import { createRouter, createWebHistory } from 'vue-router'
import Layout from "@/layout/Layout";

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: "/login",
    children: [
      {
        path: 'adminView',
        name: 'Admin',
        component: () => import("../views//Admin.vue")
      },
      {
        path: 'config/:userId?',
        name: 'config',
        component: () => import( '../views/AccessConfig.vue')
      },
      {
        path: 'personConfig/:userId?',
        name: 'personConfig',
        component: () => import( '../views/PersonalConfig.vue')
      },
      {
        path: 'viewFile',
        name: 'viewFile',
        component: () => import("../views/viewFile.vue")
      },
      {
        path: 'outlookConfig',
        name: 'outlookConfig',
        component: () => import("../views/OutlookConfig.vue")
      },
    ]
  },
  // {
  //   path: '/config/:userId?',
  //   name: 'config',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AccessConfig.vue')
  // },
  {
    path: '/upload/:UserSfid/:objName/:objId',
    name: 'upload',
    component: () => import(/* webpackChunkName: "about" */ '../views/uploadFile.vue')
  },
  // {
  //   path: '/personConfig/:userId?',
  //   name: 'personConfig',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/PersonalConfig.vue')
  // },
  {
    path: '/auth_page/:UUID/:authCode?',
    name: 'authPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/AuthPage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("../views/Login.vue")
  },
  // {
  //   path: '/testBg',
  //   name: 'testBg',
  //   component: () => import("../views/testBg.vue")
  // },
  {
    path: '/password',
    name: 'Password',
    component: () => import("../views/Password.vue")
  },
  // {
  //   path: '/admin',
  //   name: 'Admin',
  //   component: () => import("../views//Admin.vue")
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
